import $ from "jquery";
import { checkNested, getMeta, createGuid } from "./general_functions";
// import { cloudinary } from "cloudinary-core";
// var cl = new cloudinary({ cloud_name: "ssp", secure: true });

export const getImageByContentId = (id, cb) => {
    if (id) {
        $.getJSON(window.apiUrl + "/api/PublicContentApi/find/" + id).done(function(data) {
            const meta = getMeta(data);
            let img = {
                url: data.path,
                filename: data.filename,
                desc: meta.BildeAlternativTekst
            }
            cb(img);
        });
    }
}

export const getImage = (id, all) => {
    let url = "";
    $.each(all, function(nr, obj) {
        if (id === obj.contentId) {
            url = obj.path;
        }
    });
    // return "//res.cloudinary.com/ssp/image/fetch/g_center,w_1200,h_400,c_lfill/" + url;
    return "//res.cloudinary.com/ssp/image/fetch/g_center,w_1200,c_lfill/" + url;
}

export const setResponsiveImages = () => {


    $("[data-src]").each(function() {

        const me = $(this);
        let width = Math.floor($(this).width());
        const maxHeight = parseInt($(this).css("max-height"));
        const containerHeight = Math.floor($(this).height());
        const url = $(this).data("src")

        let height = (maxHeight > 0 ? (height > 0 ? height : maxHeight) : 0);
        width = width > 0 ? width : 270;

        if (!url.match("res.cloudinary")) {
            $.getJSON("https://res.cloudinary.com/ssp/image/fetch/fl_getinfo/" + url).done(function(data) {


                const orgwidth = data.input.width;
                const factor = width / orgwidth;

                const factorHeight = data.input.height * factor;


                if (factorHeight < height) {
                    height = Math.floor(factorHeight);
                }

                if (height > 0) {
                    height = `h_${height},`;
                }
                else {
                    height = ``;
                }
                // me.attr("src", ` //res.cloudinary.com/ssp/image/fetch/g_center,w_${width},${height}c_fill/${url}`);
                me.attr("src", ` //res.cloudinary.com/ssp/image/fetch/g_center,w_${width},c_fill/${url}`);

            })
        }


    });

}


export const setImages = (content) => {
    var html = $("<div class='article-parse'>" + content + "</div>");
    html.find(".gallery img").each(function() {
        let img = $(this);
        var src = img.attr("src")
        // if(img.attr("longdesc")) 
        img.attr("data-src", src);
        img.attr("data-styles", img.attr("style"));
        img.removeAttr("style");
        img.attr("src", "//res.cloudinary.com/ssp/image/fetch/h_125,c_fill/" + (src.match(/https/ig) ? src : window.location.protocol + "/" + src));
        img.addClass("aim--edit aim--gallery");
    });
    html.find("img:not(.aim--gallery)").each(function() {
        let url = "https://res.cloudinary.com/ssp/image/fetch/c_fill,g_auto,w_auto:50:650,q_auto,f_auto/" + $(this).attr("src");
        $(this).attr({ "data-src": url, "src": url });
        $(this).addClass("aim--edit aim--stdimg");
    });
    return html.html();
}

export const setImageText = (content) => {
    $("img.aim--stdimg[longdesc]:not([longdesc=''])").each(function() {
        $(this).wrap(`<div class="article__imgtxt__conatiner">`);
        $(`<span class="article__imgtxt__text">${$(this).attr("longdesc")}</span>`).insertAfter($(this));
    });
}
